import productReducer from "./Products/productReducer";
import { applyMiddleware, createStore } from "redux";
import { ADD_PRODUCT, INCREMENT_PRODUCT } from "./Products/actionType";

const checkStock = (store) => (next) => (action) => {
    if (action.type === ADD_PRODUCT || action.type === INCREMENT_PRODUCT) {
        const product = action.payload;
        const itemOnProducts = store.getState().products.find((item) => item.id === product.id);
        if (itemOnProducts.quantity === 0) {
            alert(`${itemOnProducts.name} is out of stock`);
            return;
        }
        next(action);
    }
    else {
        next(action);
    }
}

const store = createStore(productReducer, applyMiddleware(checkStock));

export default store;